export const contrats = {
  form: {
    document: "Document",
    nb: "Nombre de destinataires",
    status: "Statut",
    createdAt: "Date de création",
    certification: "Certificat",
    title_edit: "Consulter le contrat",
  },
  actions: {
    edit: "Consulter",
  },
  header_title: "Liste des contrats",
  contractModal: {
    information: "Informations du contrat",
    status: "Statut",

    document: "Document",
    certification: "Certificat",
    downloadCertificate: "Télécharger le certificat",
    notAvailable: "Non disponible",
    createdAt: "Date de création",
    updatedAt: "Date de mise à jour",
    recipients: "Destinataires",
    name: "Nom",
    email: "Email",
    signed: "Signé",
    refused: "Refusé",
    order: "Ordre",
    signedAt: "Date de signature",
    signatureField: "Champ de signature",
    page: "Page",
    position: "Position",
    size: "Taille",
    type: "Type",
    yes: "Oui",
    no: "Non",
  },
};
